import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Actions
import { actions as staticpagesActions } from 'modules/staticpages/actions'

// Hooks
import { useRequest } from 'modules/requests/hooks'

// Types
import { CmsPage, EntityState, State, ApiRequest } from 'types'

export const useStaticPageByPath = (path?: string): { page?: CmsPage | null; request: ApiRequest } => {
  const dispatch = useDispatch()
  const pages = useSelector<State, EntityState<CmsPage>>(state => state.entities.pages)
  const pageList = Object.keys(pages).map(id => pages[id])
  const page = pageList.find(p => p.meta.slug === path)
  const fetchStaticPageRequest = useRequest('FETCH_STATIC_PAGE', path)

  useEffect(() => {
    if (!page && !fetchStaticPageRequest.isLoading && !fetchStaticPageRequest.hasError && path) {
      dispatch(staticpagesActions.loadPageByPath(path))
    }
  }, [dispatch, path, fetchStaticPageRequest.isLoading, fetchStaticPageRequest.hasError, page])

  return { page, request: fetchStaticPageRequest }
}
